<template lang="pug">
  #Footer
    div.ft-main
      v-container(fluid)
        v-row(justify='center')
          v-col(cols='12' sm='11' md='11')
            v-row

              //- Columna marca
              v-col(cols='12' sm='12' md='4')
                div.ft-brand
                  img(src='@/assets/imgFerco/logo2.png' class='ft-logo' @click='irHome()')
                  p.ft-tagline Distribuidor mayorista de ferretería y materiales de construcción.
                  div.ft-contact(v-if='settings.direccion')
                    v-icon(size='15' color='#FF6200') mdi-map-marker-outline
                    span {{settings.direccion}}
                  div.ft-contact(v-if='settings.whatsapp')
                    v-icon(size='15' color='#FF6200') mdi-whatsapp
                    a(:href='"https://wa.me/"+settings.whatsapp' target='_blank') {{settings.whatsapp}}
                  div.ft-contact(v-if='settings.instagram')
                    v-icon(size='15' color='#FF6200') mdi-instagram
                    a(:href='"https://www.instagram.com/"+settings.instagram' target='_blank') @{{settings.instagram}}
                  div.ft-skeletons(v-if='policeSett')
                    v-skeleton-loader(type='text' width='220')
                    v-skeleton-loader(type='text' width='160')

              //- Columna categorías
              v-col(cols='6' sm='6' md='4')
                div.ft-col
                  h4.ft-col-title Categorías
                  template(v-if='!policeCate')
                    div.ft-link(v-for='item in categorias' :key='item._id' @click='irProductos(item)')
                      v-icon(size='13' color='#c0c8d8') mdi-chevron-right
                      span {{item.subl_des}}
                  template(v-if='policeCate')
                    v-skeleton-loader(v-for='i in 4' :key='i' type='text' width='140' class='mb-2')

              //- Columna links
              v-col(cols='6' sm='6' md='4')
                div.ft-col
                  h4.ft-col-title Información
                  div.ft-link(@click='irContacto()')
                    v-icon(size='13' color='#c0c8d8') mdi-chevron-right
                    span Contáctenos
                  div.ft-link(@click='irAcerca()')
                    v-icon(size='13' color='#c0c8d8') mdi-chevron-right
                    span Acerca de nosotros
                  div.ft-link(@click='$router.push("/ingreso")')
                    v-icon(size='13' color='#c0c8d8') mdi-chevron-right
                    span Iniciar sesión

    div.ft-bottom
      v-container(fluid)
        v-row(justify='center')
          v-col(cols='12' sm='11' md='11')
            div.ft-bottom-inner
              span © {{new Date().getFullYear()}} Fercoven C.A. Todos los derechos reservados.
              div.ft-bottom-links
                a(href='/contacto') Contacto
                span ·
                a(href='/acerca') Acerca de

</template>
<script>
import { serverImg } from '@/services/environment'
import { EventBus } from '../Events.js'
import Api from '@/services/methods'
export default {
  data () {
    return {
      settings: {},
      mostrarP: false,
      policeCate: true,
      policeSett: true,
      catalogo: '',
      categorias: [],
      catArry: ['1', '2', '3', '4'],
      ruta: serverImg
    }
  },
  created () {
    if (this.$store.state.fercoWeb && this.$store.state.fercoWeb.co_cli) {
      this.mostrarP = true
    }
    this.initialize()
  },
  methods: {
    // verificar() {
    //   this.$nextTick(() => {
    //     $("#sobre").trigger("click");
    //   })
    //   return this.$route.name
    // },
    // ir() {
    //   this.$router.push({name: 'Home', params: { value: 'other' }})
    // },
    irHome () {
      this.$router.push('/')
    },
    irContacto () {
      this.$router.push('/contacto')
    },
    irAcerca () {
      this.$router.push('/acerca')
    },
    irProductos (item) {
      if (this.$route.name == 'Productos') {
        EventBus.$emit('buscarCategoria', item)
      } else {
        this.$router.push({ name: 'Productos', params: { categoria: item } })
      }
    },
    initialize () {
      this.policeSett = true
      Api.get('categoriaWeb/footer').then(res => {
        this.categorias = res.data
        if (res.data && res.data.length > 0) this.policeCate = false
      })
      Api.get('settings').then(res => {
        this.policeSett = false
        if (res.data && res.data[0]) {
          this.settings = res.data[0]
        }
      })
      // Api.get('settings/catalogo').then(res => {
      //   this.catalogo = res.data
      //   console.log(this.catalogo)
      // })
    }
  }
}
</script>
<style lang="scss">
@import "~@/assets/scss/footer.scss";
</style>
